<template>
    <div>
        <div class="card card-primary card-outline card-outline-tabs" id="mainform">
            <div class="card-body">
            <div class="callout callout-info">
                <small><i>(*Note: This interface is for those child who have already registered in the system before but not admitted in any school. Please fetch with correct cid number and update)</i></small>
            </div>
            <div>
                <div class="form-group row" id="searchemp">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <label class="mb-0.5"><span id="empidcid">Enter Child CID Number</span><i class="text-danger">*</i> </label>
                        <input type="text" @change="remove_error('student_id')" :class="{ 'is-invalid': student_form.errors.has('student_id') }"  class="form-control" name="student_id" id="student_id" placeholder="Enter valid CID Number of your child">
                        <has-error :form="student_form" field="student_id"></has-error>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 mt-4 pt-2">
                        <button type="button" class="btn btn-sm btn-primary" @click="loadAdmissionDetails()"><i class="fa fa-download"></i> Fetch</button>
                    </div>
                </div>
            </div>
            <hr>
            <div class="form-group">
                <h6><u>Student Details</u></h6><br>
                <div class="row form-group">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >CID No/Reference  : </label>
                        <label class="text-primary">{{std_admission_details.CidNo}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Name of Student :</label>
                        <label class="text-primary">{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >Date of Birth :</label>
                        <label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Gender :</label>
                        <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >Date of Apply :</label>
                        <label class="text-primary">{{std_admission_details.DateOfApply}}</label>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        
                        <label >Application Status:</label>
                        <label class="text-primary">{{std_admission_details.Status}}</label>
                    </div>
                </div>
            </div>
            <h6><u>Admission Class </u><small><i>(*Note: This class is when it is selected while doing registration before )</i></small></h6><br>
            <div class="row form-group" v-if="std_admission_details.class_id">
                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <label class="required" >Class: </label>
                    <label class="text-primary">{{std_admission_details.class_id}}</label>
                </div>
            </div>
            <hr><br>
            <h6><u>Parents Details</u></h6><br>
            <div class="form-group table-responsive">
                <table id="list-student-left" class="table table-bordered table-striped table-head-fixed">
                    <thead>
                        <tr>
                            <th >No.</th>
                            <th >Name</th>
                            <th >Relation</th>
                            <th >CID</th>
                            <th >Working Address</th>
                            <th >Residence Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, count) in parents_details" :key="count">
                            <td>{{ count + 1 }} </td>
                            <td>{{ item.Name }}</td>
                            <td>{{ item.Relationship }}</td>
                            <td>{{ item.CidNo }}</td>
                            <td>{{ item.WorkAddress }}</td>
                            <td>{{ item.ResidenceAddress }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr>
            <div class="callout callout-warning">
                <small><i>(*Note: After updating from here, the child will display in your registration list. If Child is already applied to different school/(s) before then it will display under Apply for Admission. You can apply to different school/(s) until school decision and student decision accepted  )</i></small>
            </div>
            <div class="row form-group fa-pull-right" id="actbtn">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button class="btn btn-primary" @click="saveForm('save')">Update </button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import { stringify } from 'querystring';

export default {
    data(){
        return{
            student_id:'',
            std_class:'',
            cidNo:'',
            genderArray:{},
            std_admission_details:'',
            parents_details:[],
             //prefedined an array of the classes
            student_form: new form({
                id:'',
            })
        }
    },

    methods:{
        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        /**
         * method to remove error
         */
        remove_error(field_id){
            if($('#'+field_id).val()!=""){
                $('#'+field_id).removeClass('is-invalid');
                $('#'+field_id+'_err').html('');
            }
        },

        loadAdmissionDetails(){
            this.cidNo=+$('#student_id').val();
            let uri = '/admissions/getStudentDetailsOfAlreadyRegistered/'+this.cidNo;
            axios.get(uri)
            .then(response => {
                if(response.data!=null && response.data!=""){
                    this.std_admission_details = response.data.data;
                    this.getStuentparentDetails(this.std_admission_details.id);
                    this.student_form.student_cid = this.std_admission_details.CidNo;
                    //checking and displaying for no record to entered cid number from admission table
                    let $checkrecord = (JSON.stringify(response.data.data));
                    if($checkrecord.includes("No record")){
                     Swal.fire({
                        text: "No records found with"+" "+$('#student_id').val()+" "+"Cid Number in new admission record",
                        icon: 'info',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Okay!',
                    });
                    }
                    if($checkrecord.includes("Admitted")){
                        Swal.fire({
                        text: "Child with this"+" "+$('#student_id').val()+" "+"Cid Number is already admitted in other school, Please contact with admistrator to go further",
                        icon: 'info',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Okay!',
                    }); 
                    }
                }
            });
		},
        getStuentparentDetails(id){
            axios.get('admissions/getStuentparentDetails/'+id+'__newDetails')
            .then(response => {
                let data = response.data;
                if(data!="" || data!=null || data!=undefined){
                    this.parents_details=data;
                }
            })
            .catch(function (error) {
                console.log("Error......"+error)
            });
        },
        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid select2');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
        },
        saveForm: function(type){
            if(type=="save"){
                Swal.fire({
                    text: "Are you sure you wish to update ?",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!',
                    }).then((result) => {
                this.student_form.post('/admissions/UpdateAdmissionDetails',this.student_form)
                    .then(() => {
                        let message="You have updated successfully";
                        this.$router.push({name:'apply_for_school_ackowlegement',params: {data:message}});
                })
            })
                .catch(() => {
                    console.log("Error......")
                })
            }
		},
    },
    async mounted() {
        this.loadGenderList();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.student_form.userId=data.id;
        })
        .catch(errors => {
            console.log(errors)
        });

        $('.select2').select2({
        theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });
        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });

        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
    }
}
</script>
